// extracted by mini-css-extract-plugin
module.exports = {"stockfloor":"stockfloor_stockfloor__1LOte","stockfooltable":"stockfloor_stockfooltable__3qr9Q","content":"stockfloor_content__2z3J0"};